import { render, staticRenderFns } from "./whitelist.vue?vue&type=template&id=40980bc6&scoped=true&"
import script from "./whitelist.vue?vue&type=script&lang=js&"
export * from "./whitelist.vue?vue&type=script&lang=js&"
import style0 from "./whitelist.vue?vue&type=style&index=0&id=40980bc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40980bc6",
  null
  
)

export default component.exports